<template>
  <div class="package">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container mt--6 minHeight">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card no-body body-classes="px-0 pb-1" footer-classes="pb-2" class="createPackageContainer">
            <div slot="header" class="row align-items-center">
              <div class="col-lg-10 col-8">
                <h3 class="mb-0">{{ action === 'create' ? 'Add' : 'Update' }} Member Package</h3>
              </div>
            </div>

            <b-row id="packageFormContainer">
              <div class="col-lg-12 col-md-12 col-12">
                <b-card no-body>
                  <b-row v-if="currentUserGroup == 1">
                    <b-col md="12">
                      <div class="highlight-msg py-2 px-5">
                        <b-row>
                          <b-col>
                            <span class="text-gray text-sm text-uppercase">Company</span>
                            <h3 class="card-heading mb-1">{{ companyName }}</h3>
                          </b-col>
                        </b-row>
                      </div>
                      <hr class="m-0" />
                      <p class="text-center m-0">
                        <i class="fa fa-angle-down text-gray"></i>
                      </p>
                    </b-col>
                  </b-row>
                  <b-card-body class="pt-0">
                    <b-row>
                      <form class="w-100">
                        <div class="p-lg-4 px-lg-4 px-md-4 px-sm-4">
                          <div class="row px-4">
                            <div class="col-lg-4">
                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="name">Package Name </label>
                                <input
                                  v-model.trim="name"
                                  v-validate="'required'"
                                  type="text"
                                  name="name"
                                  data-vv-as="name"
                                  data-vv-name="name"
                                  placeholder="Enter Package Name"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('name'),
                                    'has-invalid': errors.has('name'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('name')">
                                  {{ errors.first('name') }}
                                </div>
                              </b-form-group>
                            </div>
                            <div class="col-lg-8">
                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="`benefitDescription`">Package Description </label>
                                <ckeditor id="benefitDescription" v-model="benefitDescription" :editor="editor" :config="editorConfig"></ckeditor>
                              </b-form-group>
                            </div>
                          </div>
                          <div class="row px-4">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                              <label class="w-100 form-control-label" for="`benefitDescription`">Package Contents </label>
                            </div>
                            <div v-if="contentsList.length > 0" class="col-lg-12">
                              <div v-for="(item, index) in contentsList" :key="index" class="row mb-3 contentRow">
                                <div class="col-lg-5 col-md-6 col-sm-12">
                                  <b-form-group role="group" class="mb-3 has-feedback">
                                    <label class="w-100 form-control-label" for="`${'title'+index}`">Title </label>
                                    <input
                                      v-model.trim="title[index]"
                                      v-validate="'required'"
                                      type="text"
                                      :name="'title' + index"
                                      data-vv-as="title"
                                      placeholder="Enter Title"
                                      class="form-control no-instruction"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has('title' + index),
                                        'has-invalid': errors.has('title' + index),
                                      }" />

                                    <div class="invalid-feedback" :is-invalid="errors.has('title' + index)">
                                      {{ errors.first('title' + index) }}
                                    </div>
                                  </b-form-group>

                                  <b-form-group role="group" class="mb-3 has-feedback">
                                    <label class="w-100 form-control-label" for="`${'description'+index}">Description </label>
                                    <input
                                      v-model.trim="description[index]"
                                      v-validate="'required'"
                                      type="text"
                                      :name="'description' + index"
                                      data-vv-as="description"
                                      placeholder="Enter Description"
                                      class="form-control no-instruction"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has('description' + index),
                                        'has-invalid': errors.has('description' + index),
                                      }" />
                                    <div class="invalid-feedback" :is-invalid="errors.has('description' + index)">
                                      {{ errors.first('description' + index) }}
                                    </div>
                                  </b-form-group>

                                  <b-form-group role="group" class="mb-3 has-feedback">
                                    <label class="w-100 form-control-label" for="`${'link'+index}">Link <small>(Please use http: or https://)</small></label>
                                    <input
                                      v-model.trim="link[index]"
                                      v-validate="'required|url: {require_protocol: true }'"
                                      type="text"
                                      :name="'link' + index"
                                      data-vv-as="link"
                                      placeholder="Enter Link"
                                      class="form-control no-instruction"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has('link' + index),
                                        'has-invalid': errors.has('link' + index),
                                      }" />
                                    <div class="invalid-feedback" :is-invalid="errors.has('link' + index)">
                                      {{ errors.first('link' + index) }}
                                    </div>
                                  </b-form-group>
                                </div>
                                <div class="col-lg-6 col-md-5 col-sm-12 no-gutter-left">
                                  <b-form-group role="group" class="mb-3 has-feedback">
                                    <label class="w-100 form-control-label" :for="'image' + index">Image </label>
                                    <b-form-file
                                      :id="'image' + index"
                                      ref="coverPhotofileInput"
                                      accept="image/png, image/jpeg"
                                      :name="'image' + index"
                                      placeholder="Choose or Drag photo here..."
                                      drop-placeholder="Drop file here..."
                                      :class="{
                                        hidden: imageUrl[index],
                                        'is-invalid': hasImageError[index],
                                        'has-invalid': hasImageError[index],
                                      }"
                                      class="uploadPhotos form-control"
                                      @change="imageFileChange(index, $event)"></b-form-file>
                                    <div class="invalid-feedback" :is-invalid="hasImageError[index]">
                                      {{ imageError[index] }}
                                    </div>
                                    <div v-if="imageUrl[index]" class="imageContainer">
                                      <a class="upload-image-link" @click="changeImage(index)">
                                        <div class="upload-image-overlay">Choose photo here...</div>
                                        <img v-if="imageUrl[index]" :src="imageUrl[index]" class="mw-100 mx-auto image-preview" />
                                      </a>
                                    </div>
                                  </b-form-group>
                                </div>
                                <div class="col-lg-1 col-md-1">
                                  <a v-b-tooltip.hover class="closeProductContent text-gray" title="Remove Row" @click="removeRow($event, index)"
                                    ><i class="far fa-times-circle"></i
                                  ></a>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="col-lg-12 my-3">
                                  <a class="text-success btn btn-outline-success hover-white" @click="addRow(1)"
                                    ><i class="fas fa-plus-circle"></i> Add Content</a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mt-5 px-4">
                            <div class="col-lg-5 col-md-5 col-12">
                              <router-link ref="clear" :to="`/packages/list`" exact class="btn btn-outline-vobo pr-5 pl-5 w-sm-100">Cancel</router-link>
                            </div>
                            <div class="col-lg-7 col-md-7 col-12">
                              <button
                                v-if="action === 'create'"
                                id="createPackage"
                                v-promise-btn="{ minTimeout: 1500 }"
                                type="button"
                                :disabled="loading"
                                class="btn btn-vobo float-right w-sm-100 mb-3 mb-md-0"
                                @click="createPackage">
                                Create Package
                              </button>
                              <button
                                v-if="action === 'edit'"
                                id="updatePackage"
                                v-promise-btn="{ minTimeout: 1500 }"
                                type="button"
                                :disabled="loading"
                                class="btn btn-vobo float-right w-sm-100 mb-3 mb-md-0"
                                @click="updatePackage">
                                Save Changes
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </b-row>
                  </b-card-body>
                </b-card>
              </div>
            </b-row>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import * as Cookies from 'js-cookie';
import { Validator } from 'vee-validate';

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
// import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/base64uploadadapter'
import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
// import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter'
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';
// import UploadAdapterPlugin from 'ckeditor5-upload-adapter'

import Link from '@ckeditor/ckeditor5-link/src/link';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
import List from '@ckeditor/ckeditor5-list/src/list';
import Font from '@ckeditor/ckeditor5-font/src/font';
import BlockToolbar from '@ckeditor/ckeditor5-ui/src/toolbar/block/blocktoolbar';
import HeadingButtonsUI from '@ckeditor/ckeditor5-heading/src/headingbuttonsui';
import ParagraphButtonUI from '@ckeditor/ckeditor5-paragraph/src/paragraphbuttonui';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';

import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import { NotificationTypes, wrapNotification } from '@/utils/notification';

import { API_URL } from '@/api/constants/baseUrl';

Vue.use(Cookies);

export default {
  data() {
    return {
      editor: ClassicEditor,
      benefitDescription: '',
      editorConfig: {
        plugins: [
          EasyImage,
          // Base64UploadAdapter,
          // UploadAdapter,
          // UploadAdapterPlugin,
          SimpleUploadAdapter,
          EssentialsPlugin,
          Heading,
          BoldPlugin,
          ItalicPlugin,
          BlockQuote,
          Underline,
          LinkPlugin,
          ParagraphPlugin,
          Link,
          List,
          Alignment,
          Indent,
          IndentBlock,
          Font,
          HeadingButtonsUI,
          ParagraphButtonUI,
          Alignment,
          Image,
          ImageToolbar,
          ImageCaption,
          ImageStyle,
          Autoformat,
          // SimpleUpload
        ],
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'underline',
          'blockQuote',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'outdent',
          'indent',
          '|',
          'undo',
          'redo',
          '|',
          'link',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'alignment:left',
          'alignment:right',
          'alignment:center',
          'alignment:justify',
          '|',
          'imageUpload',
          'imageStyle:side',
          'imageStyle:full',
        ],
        image: {
          toolbar: ['imageTextAlternative', 'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight'],
          styles: ['full', 'side', 'alignLeft', 'alignCenter', 'alignRight'],
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph',
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1',
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2',
            },
          ],
        },
        indentBlock: {
          classes: [
            'custom-block-indent-a', // First step - smallest indentation.
            'custom-block-indent-b',
            'custom-block-indent-c', // Last step - biggest indentation.
          ],
        },
        simpleUpload: {
          uploadUrl: `${API_URL}/ckeditor`,
          withCredentials: true,
          headers: {
            Authorization: `${Cookies.get('user-token')}`,
          },
        },
      },
      action: '',
      package: {},
      packageID: '',
      name: '',
      title: [],
      description: [],
      link: [],
      image: [],
      imageUrl: [],
      imageFileName: [],
      invalidImages: false,
      contentsList: [],
      removedContent: [],
      hasImageErrorList: [],
      imageError: [],
      disableSubmitButton: true,
    };
  },
  computed: {
    loading() {
      return this.$store.state.packages.loading;
    },
    packages: {
      get: function () {
        let data = [];

        return [{ value: null, text: 'Please select package', disabled: true }, ...data];
      },
      set: function (newValue) {
        return newValue;
      },
    },
    selectedCompany: {
      get: function () {
        let selectedCompany = this.$store.state.company.selectedCompany || Cookies.get('companyID');
        return selectedCompany;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    companyName: {
      get: function () {
        let company = this.$store.state.company.company || null;
        if (!company) {
          return null;
        }
        return company.name;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    currentCompany: {
      get: function () {
        let currentCompany = this.$store.state.user.companyID;
        return currentCompany;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    currentUserGroup() {
      return this.$store.state.user.userGroup || null;
    },
    hasImageError() {
      return this.hasImageErrorList;
    },
  },
  watch: {
    contentsList: function (value) {
      if (value.length == 0) {
        this.image = [];
        this.imageUrl = [];
        this.link = [];
        this.description = [];
        this.hasImageErrorList = [];
      }
    },
  },
  mounted() {
    const packageFormContainer = document.getElementById('packageFormContainer');
    packageFormContainer.classList.add('non-clickable');

    let companyID = Cookies.get('companyID') || '';

    if (!companyID || companyID === '') {
      this.$swal
        .fire({
          type: 'warning',
          position: 'center',
          imageWidth: 150,
          title: 'Organization is Required',
          html: 'Please select organization from the dropdown first located in upper left of the screen in order to create packages',
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'Go back to package list',
          confirmButtonClass: 'btn btn-primary pr-5 pl-5',
          footer: '<div class="text-center"> </div>',
          buttonsStyling: false,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.value) {
            this.$router.push('/packages/list');
          }
        });
      packageFormContainer.classList.add('non-clickable');
    } else {
      this.companyID = companyID;
      packageFormContainer.classList.remove('non-clickable');

      if (this.$route.params.id) {
        this.getPackage(this.$route.params.id);
        this.action = 'edit';
      } else {
        this.action = 'create';
      }
    }
  },
  methods: {
    createPackage() {
      const promiseBtn = document.getElementById('createPackage');
      const promiseBtnInner = promiseBtn.querySelector('.promise-btn__spinner-wrapper');
      promiseBtnInner.classList.remove('hidden');
      promiseBtn.setAttribute('disabled', 'disabled');

      /*for (var i = 0; i < this.contentsList.length; i++) {
          if (this.imageUrl[i] == undefined) {
            this.imageError[i] = "Image is required"
            this.$set(this.hasImageErrorList, i, true)
          } else {
            this.hasImageErrorList[i]
          }
        }

        const imageValidChecker = Promise.all(this.hasImageErrorList)

        imageValidChecker.then((isValid) => {
          const areValidFields = isValid.every(isValid => !isValid)
          this.invalidImages = !areValidFields
        })*/

      return this.$validator.validateAll().then((isValid) => {
        // if (!this.invalidImages) {
        if (isValid) {
          const formData = new FormData();

          this.package = {
            package_name: this.name,
            benefits_description: this.benefitDescription,
            title: this.title,
            description: this.description,
            link: this.link,
          };

          if (this.selectedCompany) {
            this.package.companyID = this.selectedCompany || '';
          } else {
            this.package.companyID = '';
          }

          const { package_name, benefits_description, title, description, link, companyID } = this.package;
          formData.append(
            'package',
            JSON.stringify({
              package_name,
              benefits_description,
              title,
              description,
              link,
              companyID,
            })
          );

          for (var index in this.image) {
            formData.append('image' + index, this.image[index]);
          }

          this.$store
            .dispatch('packages/CREATE_PACKAGE', formData)
            .then((res) => {
              if (res.data.success) {
                wrapNotification(this.$notify, NotificationTypes.Success, this.$options.filters.capitalizeWords('Member Package successfully created'));

                this.package = {};
                this.packageID = '';
                this.name = '';
                (this.benefitDescription = ''), (this.title = []);
                this.description = [];
                this.link = [];
                this.image = [];
                this.imageUrl = [];
                this.invalidImages = false;
                this.contentsList = [{}];
                this.hasImageErrorList = [];
                this.imageError = [];

                this.$router.push('/packages/list');
              } else {
                wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords('Error creating Member Package'));
              }
              promiseBtnInner.classList.remove('hidden');
              promiseBtn.setAttribute('disabled', 'disabled');
            })
            .catch((err) => {
              console.error(err);
              err.then((error) => {
                wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
                this.hasError = true;
              });
              promiseBtnInner.classList.remove('hidden');
              promiseBtn.setAttribute('disabled', 'disabled');
            });
        }
        // }
      });
    },
    getPackage(packageID) {
      this.$store.dispatch('packages/GET_PACKAGE_BY_ID', packageID).then((resp) => {
        this.packageID = resp._id;
        this.name = resp.package_name;
        this.benefitDescription = resp.benefits_description;
        this.title = resp.title;
        this.description = resp.description;
        this.link = resp.link;
        this.imageUrl = resp.image;
        this.imageFileName = resp.imageFileName || [];

        for (let key in this.title) {
          this.contentsList.push({});
        }
      });
    },
    updatePackage() {
      const promiseBtn = document.getElementById('updatePackage');
      const promiseBtnInner = promiseBtn.querySelector('.promise-btn__spinner-wrapper');
      promiseBtnInner.classList.remove('hidden');
      promiseBtn.setAttribute('disabled', 'disabled');

      /*for (var i = 0; i < this.contentsList.length; i++) {
          if (this.imageUrl[i] == undefined) {
            this.imageError[i] = "Image is required"
            this.$set(this.hasImageErrorList, i, true)
          } else {
            this.hasImageErrorList[i]
          }
        }

        const imageValidChecker = Promise.all(this.hasImageErrorList)

        imageValidChecker.then((isValid) => {
          const areValidFields = isValid.every(isValid => !isValid)
          this.invalidImages = !areValidFields
        })*/

      return this.$validator.validateAll().then((isValid) => {
        ///if (!this.invalidImages) {
        if (isValid) {
          const formData = new FormData();

          this.package = {
            package_name: this.name,
            benefits_description: this.benefitDescription,
            title: this.title,
            description: this.description,
            link: this.link,
            imageFileName: this.imageFileName,
          };

          if (this.selectedCompany) {
            this.package.companyID = this.selectedCompany || '';
          } else {
            this.package.companyID = '';
          }

          const { package_name, benefits_description, title, description, link, companyID, imageFileName } = this.package;
          const packageID = this.packageID;

          formData.append(
            'package',
            JSON.stringify({
              package_name,
              benefits_description,
              title,
              description,
              link,
              companyID,
              imageFileName,
            })
          );
          formData.append('removedContent', JSON.stringify({ removedItems: this.removedContent }));

          for (var index in this.image) {
            formData.append('image' + index, this.image[index]);
          }

          this.$store
            .dispatch('packages/UPDATE_PACKAGE', { formData, packageID })
            .then((res) => {
              if (res.data.success) {
                wrapNotification(this.$notify, NotificationTypes.Success, this.$options.filters.capitalizeWords('Member Package successfully updated'));
                this.removedContent = [];
                this.$router.push('/packages/list');
              } else {
                wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords('Error updating Member Package'));
              }
              promiseBtnInner.classList.remove('hidden');
              promiseBtn.setAttribute('disabled', 'disabled');
            })
            .catch((err) => {
              console.error(err);
              err.then((error) => {
                wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
                this.hasError = true;
              });
              promiseBtnInner.classList.remove('hidden');
              promiseBtn.setAttribute('disabled', 'disabled');
            });
        }
        ///}
      });
    },
    checkRole: function (val) {
      if (val == 4 && (this.selectedCompany == null || this.selectedCompany == '')) {
        wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords('Please Select Organization First'));
      }
    },
    imageFileChange(index, e) {
      let file = e.target.files[0];
      if (!file) {
        file = e.dataTransfer.files[0];
      }
      var acceptedFiletypes = ['image/jpeg', 'image/jpg', 'image/png'];

      var fileType = String(file.type);
      if (!acceptedFiletypes.includes(fileType)) {
        this.imageError[index] = 'invalid file type, only png & jpeg are supported';
        this.$set(this.hasImageErrorList, index, true);
        this.$set(this.images, index, undefined);
        return;
      }

      this.image[index] = file;
      this.$set(this.imageUrl, index, URL.createObjectURL(file));
      if (this.imageUrl[index]) {
        this.$set(this.hasImageErrorList, index, false);
      }

      /*this.imageUrl[index] = URL.createObjectURL(file)
        if (this.image[index]) {
          this.$set(this.hasImageErrorList, index, false)
        }
        console.log(this.hasImageErrorList)
        console.log(this.image[index])*/
    },
    changeImage(index) {
      document.getElementById('image' + index).click();
    },
    addRow: function (count) {
      var numRows = this.contentsList.length;

      if (numRows >= 10) return;

      for (var i = 1; i <= count; i++) {
        this.contentsList.push({});
        if (++numRows == 10) break;
      }
    },
    removeRow: function (row, index) {
      this.contentsList.splice(row, 1);

      for (var i = 0; i < this.title.length; i++) {
        if (i === index) {
          this.title.splice(i, 1);
          this.imageUrl.splice(i, 1);
          this.description.splice(i, 1);
          this.link.splice(i, 1);
          this.image.splice(i, 1);
        }
      }

      this.removedContent.push(index);
    },
  },
};
</script>
<style lang="scss">
.createPackageContainer select,
.createPackageContainer textarea {
  color: #525f7f !important;
}
.ck-content {
  height: 300px;
}
.contentRow {
  border-top: 1px solid #dfdfdf;
  padding-top: 10px;
}

.closeProductContent {
  font-size: 20px;
  margin-top: 8px;
  float: right;
}
.package .imageContainer {
  height: 230px;
  position: relative;
}

a.hover-white:hover {
  color: #ffffff !important;
}

.package .uploadPhotos .custom-file-label {
  border: 0 !important;
}

.imageContainer {
  height: 230px;
  position: relative;
  border-radius: 7px;
}
.image-preview {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 0.375rem;
}
.upload-image-link {
  width: 100%;
  height: 100%;
}
.upload-image-link:hover .upload-image-overlay {
  display: block;
}
.upload-image-overlay {
  width: 100%;
  height: 100%;
  border-radius: 0.375rem;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  text-align: center;
  color: #e5e5e5;
  height: 230px;
  display: none;
  line-height: 230px;
}
</style>
